<template>
    <div>
        <div id="serial_footer_wrapper">
            <div id="serial_bzbslogo">
                <img src="@/assets/bzbslogo/buzzebees-logo-dark.svg"/>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'SerialFooter',
}
</script>
<style lang="scss" scoped>
#serial_footer_wrapper {
    padding: {
        top: 20px;
        left: 25px;
        right: 25px;
        bottom: 20px;
    };

    #serial_bzbslogo {
        img {
            display: block;
            height: 20px;
            margin: {
                left: auto;
                right: auto;
            };
        }
    }
}
</style>
